export const agenda = {
  agendaDuration: 'duración',
  agendaCurtainCopy: 'Copiar enlace',
  agendaCurtainFlag: 'Marcar contenido',
  agendaCurtainFlagSent: 'Contenido reportado',
  agendaLinkCopied: '¡Enlace copiado!',
  agendaStartsAt: 'Comienza a las ',
  agendaEndsAt: 'Termina a las ',
  agendaSpeakers: 'Oradores',
  agendaSeeAllSpeakers: 'Ver todos',
  agendaAddToSchedule: 'Agregar a mi agenda',
  agendaRemoveFromSchedule: 'Eliminar de mi agenda',
  agendaAddedToSchedule: '¡Añadido a mi agenda!',
  agendaRemovedFromSchedule: '¡Eliminado de mi agenda!',
  agendaCalendar: 'Calendario',
  agendaAddToCalendar: '¿Añadir al calendario del sistema?',
  agendaCalendarSkip: 'Saltar',
  agendaCalendarAdd: 'Añadir',
  agendaNow: 'AHORA',
  agendaModerators: 'Moderadores',

  QnATitle: 'Preguntas y respuestas',
  askASpeaker: 'Preguntar a un orador',
  askAQuestion: 'Hacer una pregunta',
  askQuestionPlaceholder: 'Escribe tu pregunta aquí',
  cancel: 'Cancelar',
  ask: 'Preguntar',
  deleteConfirmation: '¿Deseas eliminar esta pregunta?',
  questionDeleted: '¡Pregunta eliminada con éxito!',
  rateSession: 'Califica esta sesión'
}
